export default "__VITE_ASSET__B0B1jGBb__"